// General
import Vue from 'vue'
import store from './store'
import ApiService from './services/api'

// Plugins
import VueSlideUpDown from 'vue-slide-up-down'
import Vuebar from 'vuebar'
import { i18n } from '@src/localization/config'
import GAPlugin from './directives/gaplugin'

// Custom components
import { Ga } from './directives/Ga.js'
import Accordion from './views/accordion/Accordion.vue'
import AccordionItem from './views/accordion/AccordionItem.vue'
import Calc from './views/calc/index.vue'
import Clients from './views/clients/clients.vue'
import AuthorizedClients from './views/clients/authorizedClients.vue'
import Stickers from './views/stickers/index.vue'
import StickersUploader from './views/stickersUploader/index.vue'
import DeletionRequest from './views/account/deletionRequest.vue'

import '../sass/app.scss'

// window.Vue = Vue

ApiService.init()

Vue.use(Vuebar)
Vue.use(GAPlugin)

Vue.directive('da-ga', Ga)

Vue.component('vue-slide-up-down', VueSlideUpDown)
Vue.component('da-accordion', Accordion)
Vue.component('da-accordion-item', AccordionItem)
Vue.component('da-calc', Calc)
Vue.component('da-passport-clients', Clients)
Vue.component('da-passport-authorized-clients', AuthorizedClients)
Vue.component('da-stickers', Stickers)
Vue.component('da-stickers-uploader', StickersUploader)
Vue.component('da-account-deletion-request', DeletionRequest)


window.destroyVueApp = function () {
  window.vm.$destroy()
}

window.initVueApp = function () {
  if (window.vm) {
    window.destroyVueApp()
    delete window.vm
  }

  if (document.getElementById('app')) {
    console.log('[Legacy dashboard app] Creating vm...')

    window.vm = new Vue({
      store,
      i18n,
      el: '#app',
    })
  }
}

setTimeout(() => {
  if (!window.vm) {
    window.initVueApp()
  }
}, 200)

// document.addEventListener('DOMContentLoaded', function () {
//     window.initVueApp()
// })
